jQuery(document).ready(function ($) {
    $(".toggle_products").click(function() {
        if($(this).text() == "Show") {
            $(this).text("Hide")
            $(".bg_overlay").css("opacity", 1)
            $(".bg_overlay").show()
            $(".article_body.flex_container .related").css("opacity", 1)
            $(".article_body.flex_container .related").show()
        }
        else {
            $(this).text("Show")
            $(".bg_overlay").css("opacity", 0)
            $(".bg_overlay").hide()
            $(".article_body.flex_container .related").css("opacity", 0)
            $(".article_body.flex_container .related").hide()
        }
    })
});